// import axios from "axios";
// import {
//   AppVersionClient,
//   ImagesClient,
//   RecipeCollectionsClient,
//   RecipesClient,
//   ShoppingListsClient,
//   UsersClient,
// } from "./clients";

// //If you don't add this, the auto-generated client will attempt to json.parse an already JSON object and error.
// axios.defaults.transformResponse = [];

// // axios.interceptors.request.use(async (request) => {
// //   const session = await getSession();
// //   request.data;

// //   if (session) {
// //     if (session.error) {
// //       //If there's an error refreshingthe token - force a new sign in
// //       logger.error(
// //         session.error,
// //         "Error occurred in the SEssion object. Forcing new sign-in"
// //       );
// //       console.error(
// //         session.error,
// //         "Error occurred in the SEssion object. Forcing new sign-in"
// //       );
// //       await signIn("auth0");
// //     }

// //     request.headers.Authorization = `Bearer ${session.access_token}`;
// //   }
// //   return request;
// // });
// //NOTE: REMOVING the default recipelogprd URL as a backup. Just to make sure this doesnt get pushed anuwhere...
// const baseUrl = process.env.NEXT_PUBLIC_BACKEND_API_URL || "";

// if (!baseUrl) {
//   throw new Error("Must provide a base URL");
// }
// // axios.defaults.baseURL =
// //   process.env.NEXT_PUBLIC_BACKEND_API_URL ||
// //   "https://recipelogprd.azurewebsites.net";
// axios.defaults.baseURL = baseUrl;

// export const appVersionClient = new AppVersionClient(baseUrl, axios);
// export const imagesClient = new ImagesClient(baseUrl, axios);
// export const recipeCollectionsClient = new RecipeCollectionsClient(
//   baseUrl,
//   axios
// );
// export const recipesClient = new RecipesClient(baseUrl, axios);
// export const shoppingListsClient = new ShoppingListsClient(baseUrl, axios);
// export const usersClient = new UsersClient(baseUrl, axios);

import axios from "axios";
import { Client } from "./clients";
import { defaultApiUrl } from "./defaultApiUrl";

//If you don't add this, the auto-generated client will attempt to json.parse an already JSON object and error.
axios.defaults.transformResponse = [];

axios.defaults.baseURL =
  process.env.NEXT_PUBLIC_BACKEND_API_URL ||
  defaultApiUrl;

const apiClient = new Client(
  process.env.NEXT_PUBLIC_BACKEND_API_URL ||
    defaultApiUrl,
  axios
);
export default apiClient;
